/* @ts-ignore */
import * as Types from '../../../graphql/generated/graphql.g';

import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type ClientApplicationsLastUsedTimeStatQueryVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
  applicationId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
}>;


export type ClientApplicationsLastUsedTimeStatQuery = { __typename: 'Query', employeeSessions?: { __typename: 'ClientEmployeeSessionTypeConnection', aggregate?: { __typename: 'ClientEmployeeSessionAggregateType', max?: { __typename: 'ClientEmployeeSessionAggregateMaxFieldType', updatedAt?: string | null } | null } | null } | null };



export const ClientApplicationsLastUsedTimeStatDocument = `
    query ClientApplicationsLastUsedTimeStat($clientId: UUID!, $applicationId: UUID) {
  employeeSessions(clientId: $clientId, applicationId: $applicationId) {
    aggregate {
      max {
        updatedAt
      }
    }
  }
}
    `;

export const useClientApplicationsLastUsedTimeStatQuery = <
      TData = ClientApplicationsLastUsedTimeStatQuery,
      TError = unknown
    >(
      variables: ClientApplicationsLastUsedTimeStatQueryVariables,
      options?: Omit<UseQueryOptions<ClientApplicationsLastUsedTimeStatQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ClientApplicationsLastUsedTimeStatQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ClientApplicationsLastUsedTimeStatQuery, TError, TData>(
      {
    queryKey: ['ClientApplicationsLastUsedTimeStat', variables],
    queryFn: fetcher<ClientApplicationsLastUsedTimeStatQuery, ClientApplicationsLastUsedTimeStatQueryVariables>(ClientApplicationsLastUsedTimeStatDocument, variables),
    ...options
  }
    )};

useClientApplicationsLastUsedTimeStatQuery.getKey = (variables: ClientApplicationsLastUsedTimeStatQueryVariables) => ['ClientApplicationsLastUsedTimeStat', variables];

export const useInfiniteClientApplicationsLastUsedTimeStatQuery = <
      TData = InfiniteData<ClientApplicationsLastUsedTimeStatQuery>,
      TError = unknown
    >(
      variables: ClientApplicationsLastUsedTimeStatQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ClientApplicationsLastUsedTimeStatQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ClientApplicationsLastUsedTimeStatQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ClientApplicationsLastUsedTimeStatQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ClientApplicationsLastUsedTimeStat.infinite', variables],
      queryFn: (metaData) => fetcher<ClientApplicationsLastUsedTimeStatQuery, ClientApplicationsLastUsedTimeStatQueryVariables>(ClientApplicationsLastUsedTimeStatDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteClientApplicationsLastUsedTimeStatQuery.getKey = (variables: ClientApplicationsLastUsedTimeStatQueryVariables) => ['ClientApplicationsLastUsedTimeStat.infinite', variables];


useClientApplicationsLastUsedTimeStatQuery.fetcher = (variables: ClientApplicationsLastUsedTimeStatQueryVariables) => fetcher<ClientApplicationsLastUsedTimeStatQuery, ClientApplicationsLastUsedTimeStatQueryVariables>(ClientApplicationsLastUsedTimeStatDocument, variables);
